import React, { forwardRef, HTMLAttributes } from "react";
import { useI18n } from "../../../../i18n/i18n";
import { CheckedState } from "../../../checkbox";
import { MultiSelectOption } from "./MultiSelectOption";

export interface SelectAllOptionProps extends HTMLAttributes<HTMLDivElement> {
    checkedState: CheckedState;
}

export const SelectAllOption = forwardRef<HTMLDivElement, SelectAllOptionProps>(({ checkedState, ...rest }, ref) => {
    const { i18n } = useI18n();
    return (
        <MultiSelectOption
            checkedState={checkedState}
            ref={ref}
            onClick={(e) => {
                rest.onClick?.(e);
            }}
            {...rest}
        >
            {i18n._(/*i18n*/ "Select All")}
        </MultiSelectOption>
    );
});

SelectAllOption.displayName = "SelectAllOption";
